/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import PropTypes from 'prop-types';
import VolumeButton from './VolumeButton';
import VolumeSlider from './VolumeSlider';
import styles from './styles/controls.css';

export const VolumeButtonAndSlider = ({
  showVolumeSlider,
  hideVolumeSlider,
  alwaysShowVolumeSlider,
  isVolumeSliderShown,
  canAudioStateBeChanged,
  ...otherProps
}) => (
  <div
    className={styles.volumeContainer}
    onMouseEnter={() => canAudioStateBeChanged && showVolumeSlider()}
    onMouseLeave={() => canAudioStateBeChanged && hideVolumeSlider()}
  >
    <VolumeButton canAudioStateBeChanged={canAudioStateBeChanged} {...otherProps} />
    {(alwaysShowVolumeSlider || isVolumeSliderShown) && (
      <VolumeSlider canAudioStateBeChanged={canAudioStateBeChanged} {...otherProps} />
    )}
  </div>
);

VolumeButtonAndSlider.propTypes = {
  alwaysShowVolumeSlider: PropTypes.bool.isRequired,
  isVolumeSliderShown: PropTypes.bool.isRequired,
  showVolumeSlider: PropTypes.func.isRequired,
  hideVolumeSlider: PropTypes.func.isRequired,
  canAudioStateBeChanged: PropTypes.bool
};

export default VolumeButtonAndSlider;